import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Antd, { Modal } from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import dayjs from "dayjs";
import $ from 'jquery';
import md5 from 'js-md5';

/*header*/
var axios = require('axios');
Vue.prototype.$jq = $;
Vue.prototype.dayjs = dayjs;
Vue.prototype.$axios = axios;
Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Antd);

import global from './config/prototype';
Vue.use(global);


// axios.defaults.baseURL = '/lnpu/api';
axios.defaults.baseURL = '/online/api';
axios.default.timeout = 6000;
axios.defaults.withCredentials = true;
axios.withCredentials = true;

var state = false;

// 添加响应拦截器
axios.interceptors.response.use(
    function (response) {
        return response
    }, function (error) {
        if (error.response.status === 401) {
            if (!state) {
                state = true;
                Modal.error({
                    title: '提醒',
                    content: '登录超时，无权访问，请重新登录?',
                    onOk: () => {
                        state = false;
                        localStorage.clear();
                        var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
                        router.push('/login');
                    }
                });
            }
        }
    });
window.onunload = () => {

};



// eslint-disable-next-line no-unused-vars
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
        if (document.cookie) {  // 通过vuex state获取当前的token是否存在
            next();
        }
        else {
            next({
                path: '/login',
                query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
            })
        }
    }
    else {
        next();
    }
    // next()
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
